import { Button, cn } from '@src/components/ui';


/** Skeleton + error primitives for per-widget isolation (UX 02: one failing
 * widget must not blank the page). */
function Skeleton({ className }) {
  return <span className={cn('block animate-pulse rounded-md bg-surface-2', className)} />;
}


function WidgetError({ onRetry, className }) {
  return (
    <div className={cn('flex flex-col items-center justify-center gap-2 p-4 text-center', className)}>
      <span className="text-[13px] text-ink-muted">Couldn&apos;t load this widget.</span>

      <Button variant="secondary" className="h-8 px-3 text-xs" onClick={onRetry}>
        Retry
      </Button>
    </div>
  );
}


Skeleton.displayName = 'Skeleton';
WidgetError.displayName = 'WidgetError';
export { Skeleton, WidgetError };
